export default __webpack_public_path__ + "static/media/abstract2.c96e3475.png";